import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../Field';

class ManualCompletion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showManualWarning: false,
        };
    }

    completeManually(e) {
        e.preventDefault();
        this.setState({
            showManualWarning: true,
        });
    }

    handleShowManualWarning(v) {
        if (v.toUpperCase() == "NO") {
            this.setState({
                showManualWarning: false,
            });
            if (this.props.noFunc) {
                this.props.noFunc();
            }
        } else if (v.toUpperCase() == "YES") {
            if (this.props.yesFunc) {
                this.props.yesFunc();
            }
        }
    }

    render() {
        return(
            <question-row class="no-border">
                <div className="question-main">
                    <a href="#" onClick={this.completeManually.bind(this)}>Or complete manually</a>
                    {this.state.showManualWarning ?
                        <div className="supplemental">
                            <div className="supplemental-bubble">
                                <div className="arrow" />
                                <p><strong>Are you sure?</strong></p>
                                <p>By getting your tenant to complete the form we get the information and the documentation we need much faster. You benefit from the following:</p>
                                <ul>
                                    <li>More time - The tenant can complete the application form freeing up your time!</li>
                                    <li>Greater accuracy – with the tenant supplying their own information it ensures accuracy and meets Data Protection requirements</li>
                                    <li>Quicker turnaround - the tenant can upload documents and provide information from the start of the process</li>
                                    <li>Less contact from us - we'll let you know when the report is complete and only contact you if absolutely necessary</li>
                                </ul>
                                <p>Do you want to continue to complete the form manually?</p>
                                <Field
                                    hasBorder={false}
                                    hasPadding={false}
                                    question=""
                                    fieldName="continueToEnterManually"
                                    type="button-choice"
                                    callbackFunction={this.handleShowManualWarning.bind(this)}
                                    options={[
                                        {
                                            value: 'yes',
                                            text: 'Yes'
                                        },
                                        {
                                            value: 'no',
                                            text: 'No'
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                        : null}
                </div>
            </question-row>
        );
    }
}

ManualCompletion.propTypes = {
    noFunc:     PropTypes.func,
    yesFunc:    PropTypes.func,
};

export default ManualCompletion;


// WEBPACK FOOTER //
// ./src/components/Fragments/ManualCompletion.js